import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import Layout from './components/Layout/index';
import theme from './themes/theme';
import RemoteModuleProvider from './components/RemoteModuleProvider/RemoteModuleProvider';
import { NotificationProvider } from './utils/NotificationContext';

function App() {
  return (
    <RemoteModuleProvider>
      <NotificationProvider>
        <ThemeProvider theme={theme}>
          {/* <UserProvider> */}
          <BrowserRouter>
            <Layout />
          </BrowserRouter>
          {/* </UserProvider> */}
        </ThemeProvider>
      </NotificationProvider>
    </RemoteModuleProvider>
  );
}

export default App;
